import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getIdentityProviderForUser = userId =>
  call(websocketFetch, 'get_identity_provider_for_user', { user_id: userId });
